var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import * as Preact from 'preact';
import * as Price from './A_Price';
import * as ApplyButton from './M_ApplyButton';
import * as ImageContainer from './M_ProductImageContainer';
import * as ProductInfo from './M_ProductInfo';
import { ProductCard } from './domain';
var ProductCardSx = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '4px',
    boxSizing: 'border-box',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    background: '#F9F9F9',
    borderRadius: '8px',
};
export var Component = function (props) {
    var _a, _b;
    var productId = ProductCard.productIdFromGood(props.productCard.good);
    if (props.productCardDetails === null) {
        return (Preact.h(ListItem, { sx: __assign({}, ProductCardSx), "data-testid": "product-card" },
            Preact.h(Box, { sx: { display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' } },
                Preact.h(ImageContainer.Component, { imageSrc: "assets/cross.png", onClick: props.onClick, sx: { width: '100%' } }),
                Preact.h(ProductInfo.Component, { name: "None" })),
            Preact.h(Box, { sx: { display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' } },
                Preact.h(ApplyButton.Component, { loading: ((_a = props.pendingSelection) === null || _a === void 0 ? void 0 : _a.productId) === productId, selected: props.productCard.status === 'selected', onClick: props.onClick, disabled: props.pendingSelection !== null }))));
    }
    return (Preact.h(ListItem, { autoFocus: props.productCard.status === 'selected', sx: __assign({}, ProductCardSx), "data-testid": "product-card" },
        Preact.h(Box, { sx: { display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' } },
            Preact.h(ImageContainer.Component, { imageSrc: props.productCardDetails.thumbnail, onClick: props.onClick, sx: { width: '100%' } }),
            Preact.h(ProductInfo.Component, { name: props.productCardDetails.name })),
        Preact.h(Box, { sx: { display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' } },
            (!props.hidePrice || props.productCardDetails.productUrl) && (Preact.h(Price.Component, { price: !props.hidePrice ? props.productCardDetails.price : undefined, infoUrl: props.productCardDetails.productUrl, trackMoreInfo: props.trackMoreInfo })),
            Preact.h(ApplyButton.Component, { loading: ((_b = props.pendingSelection) === null || _b === void 0 ? void 0 : _b.productId) === productId, selected: props.productCard.status === 'selected', disabled: props.pendingSelection !== null, onClick: props.onClick }))));
};
Component.displayName = 'ProductCard';
